<mat-card>
  <mat-card-content>
    <div class="top-banner">
      <p class="performance-year-text">
        Performance Year: <strong>{{ performanceYear }}</strong>
      </p>
    </div>

    <div class="page-header">
      <h2 class="page-title">Settings</h2>
      <div class="tin-chip" [class.missing-tin]="!hasTin">
        <span class="tin-label">TIN:</span>
        <span class="tin-value">{{ tin }}</span>
        @if (!hasTin) {
        <mat-icon
          class="warning-icon"
          matTooltip="TIN not yet entered in Step 3"
          >warning</mat-icon
        >
        }
      </div>
    </div>

    <form [formGroup]="settingsForm">
      <div class="section">
        <div class="section-header">
          <h3 class="section-title">CEHRT ID</h3>
          <mat-icon
            class="info-icon"
            matTooltip="Certified Electronic Health Record Technology"
            >help_outline</mat-icon
          >
        </div>

        <p class="section-description">
          Please provide a valid CEHRT ID in order to:
        </p>
        <ul class="requirements-list">
          <li>a. Report for the PI category of MIPS</li>
          <li>b. Be eligible to report the eCQMs in MIPS (if applicable)</li>
        </ul>

        <p class="generate-link">
          You may generate a CERT ID for your EHR/s
          <a (click)="generateCertId()" class="link">here</a>.
        </p>

        <div class="cehrt-fields">
          <div class="field-group">
            <mat-form-field appearance="outline" class="cehrt-field">
              <mat-label>CEHRT ID</mat-label>
              <input
                matInput
                formControlName="cehrtId"
                placeholder="Enter CEHRT ID"
                type="text"
                [required]="isPIRequired"
              />
            </mat-form-field>

            <mat-form-field appearance="outline" class="cehrt-field">
              <mat-label>Confirm CEHRT ID</mat-label>
              <input
                matInput
                formControlName="confirmCehrtId"
                placeholder="Re-enter CEHRT ID"
                type="text"
                [required]="isPIRequired"
              />
              @if (isFieldInvalid('confirmCehrtId')) {
              <mat-error>
                @if
                (settingsForm.get('confirmCehrtId')?.hasError('cehrtMismatch'))
                { CEHRT IDs do not match }
              </mat-error>
              }
            </mat-form-field>

            <button
              mat-raised-button
              color="primary"
              type="button"
              class="validate-button"
              (click)="validateCehrtId()"
              [disabled]="isCehrtValidating()"
            >
              @if (isCehrtValidating()) {
              <ng-container>
                <mat-icon>hourglass_empty</mat-icon>
                Validating...
              </ng-container>
              } @else {
              <ng-container> Validate </ng-container>
              }
            </button>
          </div>

          @if (showValidationSuccess) {
          <div class="validation-message success">
            Your CEHRT ID is valid for 2015 Edition Cures Update criteria at 45
            CFR 170.315(c) (1) through (3) per ONC Certification Criteria for
            Health IT.
          </div>
          } @if (showValidationWarning) {
          <div class="validation-warning">
            <mat-icon>warning</mat-icon>
            Invalid CEHRT ID. Please verify and validate before proceeding.
          </div>
          }
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-card>
